<template>

    <b-overlay :show="is_load">
    <div class="glovo_history" v-if="logs.length > 0">
        <div class="d-flex flex-row align-items-center" v-for="log in this.logs">
            <div class="mt-2 w-100">
            <div id="panel-3" class="panel  mt-1 panel-collapsed mb-0" >
                <div class="panel-hdr color-success-600 p-2 cursor-pointer"  data-action="panel-collapse" data-toggle="tooltip">

                    <div class="icon-stack display-3 flex-shrink-0 mr-2 d-none d-sm-block">
                        <i class="fal fa-circle icon-stack-3x opacity-100 "  :class="[(is_ok_state(log)) ? 'color-success-400':'color-danger-400']"></i>
                        <i class="fas fa-address-book icon-stack-1x opacity-100 " :class="[(is_ok_state(log)) ? 'color-success-500':'color-danger-500']"></i>
                    </div>

                    <h2>
                        {{ log.type }}
                        <sup class="log_info">
                            <span class="badge  ml-2" :class="[(is_ok_state(log)) ? 'badge-success':'badge-danger']">
                                {{log.status}}
                            </span>
                        </sup>
                        <span class="fw-300"><i></i></span>
                    </h2>

                    <div class="panel-toolbar">
                        <div class="mr-1  color-black">
                            {{log.added}} - {{log.updateAt}}
                        </div>
                    </div>
                </div>

                <div class="panel-container collapse" style="width: 100%" >
                    <div class="panel-content">

                        <div class="subheader mb-2 pb-2">
                            <h1 class="subheader-title">
                                <i class="subheader-icon fal fa-window"></i> RESPONSE
                            </h1>
                            <div class="flex_in cursor-pointer" v-on:click="copy(JSON.stringify(log.provider_response).trim())">
                                <i class="fal fa-copy fs-xxl"></i>
                            </div>
                        </div>
                        <div>
                            <pre style=" word-break: break-all; max-height: 350px;overflow: auto">{{ JSON.stringify(log.provider_response, null, 2).trim() }}</pre>
                        </div>

                        <div >
                            <div class="subheader mb-2 pb-2">
                                <h1 class="subheader-title">
                                    <i class="subheader-icon fal fa-window"></i> PAYLOAD
                                </h1>

                                <div class="flex_in cursor-pointer" v-on:click="copy(JSON.stringify(log.provider_data).trim())" ref="container">
                                    <i class="fal fa-copy fs-xxl"></i>
                                </div>

                            </div>
                            <div>
                                <pre style=" word-break: break-all; max-height: 350px;overflow: auto">{{ JSON.stringify(log.provider_data, null, 2).trim() }}</pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div ref="message" ></div>
        </div>
        </div>
    </div>
    </b-overlay>
</template>

<script>
export default {
    name: "location_logs",
    props : {
        location : {
            type : Object
        }
    },
    data() {
        return {
            is_load : false,
            logs : []
        }
    },

    created() {
        this.load_logs();
    },
    methods : {
        is_ok_state(log) {
            return log.status === 'operation_success' || log.status === 'operation_done';
        },

        async load_logs() {
            this.logs = [];
            this.is_load = true;
            agr_api.get('/aggregators/locations/' + this.location.id + '/logs').then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.logs = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },
    }
}
</script>

<style scoped>

</style>
